import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable, tap, of, throwError, pipe, map } from 'rxjs';
import { environment } from '@environment/environment';
import { CookieService } from 'ngx-cookie-service';
import { catchError } from 'rxjs/operators';
import { FormGroup } from '@angular/forms';
import JSEncrypt from 'jsencrypt';
import { TokenizacionResponse } from 'src/app/models/tokenizacion.model';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  callback: EventEmitter<any> = new EventEmitter();
  public requestpayment: any = [];
  public bodyrequestcard: any = [];
  public tokenacces: string = '';
  public tokencard: string = '';
  public email: string = '';
  public afilcard: Boolean = false;
  public numbermodule: number = 0;
  public tyc: Boolean = false;
  public uploadcard: Boolean = false;
  public numberphone: string = '';
  public bindcardgen: string = '**** **** **** ****';
  public expiratesdatecard: string = '';
  private readonly APIURL = environment.api;
  private readonly APICENAM = environment.serviceCENAM;
  private isNational: boolean = false;
  public emailFromDom: string = '';
  public finishpin: Boolean = false;
  public tokeNumero: string = '';
  private tokenAuth: string = '';
  private transactionIdentifier: string = '';
  private microformSrc: string = '';
  private microformIntegrity: string = '';
  public arrayLabel: string | null = null;

  constructor(
    private http: HttpClient,
    private cookie: CookieService,
    private route: ActivatedRoute
  ) {
    this.route.queryParamMap.subscribe((params) => {
      this.arrayLabel = params.get('paymentScreenData');
    });
  }


  GenerateToken(Token: string, authorization: string): Observable<any> {
    const url = `${this.APIURL}/semTkCr`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-key': authorization,
      Authorization:
        'cmViUUFLQ0NuQkNUb1BLQXU3d3FNMUFhcENMMnVzWE46Rm5XcjFUendETDNwUmQwZQ',
    });

    const body = {
      semTkCr: {
        Token: Token,
      },
    };

    return this.http.post(url, body, { headers: headers }).pipe(
      catchError((error) => {
        return throwError(
          () => new Error('Error en la solicitud GenerateTokenCorreo')
        );
      })
    );
  }

  ValidateToken(authorization: string, token: string): Observable<any> {
    const url = `${this.APIURL}/semVtCr`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-key': authorization,
      Authorization:
        'cmViUUFLQ0NuQkNUb1BLQXU3d3FNMUFhcENMMnVzWE46Rm5XcjFUendETDNwUmQwZQ',
    });

    const body = {
      semVtCr: {
        Token: token,
      },
    };

    return this.http.post(url, body, { headers: headers }).pipe(
      catchError((error) => {
        return throwError(() => new Error('Error en la solicitud'));
      })
    );
  }

// Envia el correo de confirmacion de pago utilizando el servicio semConfPay
  async sendEmailConfirmationPayment(
    authorization: string,
    cuerpo: string,
    auth : string
  ): Promise<any> {
    // Construye la URL del servicio
    const url = `${this.APIURL}/semConfPay`;
    // Configura los encabezados de la solicitud
    const headers = new HttpHeaders({
      'x-bearer-token': `Bearer ${auth}`,
      'x-api-key': authorization,
      Authorization:
        'cmViUUFLQ0NuQkNUb1BLQXU3d3FNMUFhcENMMnVzWE46Rm5XcjFUendETDNwUmQwZQ',
      'Content-Type': 'application/json',
    });

    
    // Construye el cuerpo de la solicitud
    const body = {
      semConfPay: {
        Token: cuerpo,
        Params: localStorage.getItem('paymentScreenData') ? localStorage.getItem('paymentScreenData') : '',
        Channel: localStorage.getItem('channel')
      },
    };
    
    // Realiza la solicitud POST y maneja la respuesta
    try {
      const response = await this.http.post(url, body, { headers }).toPromise();
      // Retorna la respuesta del servicio
      return response;
    } catch (error) {
      // Lanza un error si la solicitud falla
      throw new Error('Error en la solicitud');
    }
  }

  sendEmailConfirmationDAM(
    authorization: string,
    cuerpo: string,
    auth : string
  ): Observable<any> {
    const url = this.APIURL + `/semConfDAM`;
    const headers = new HttpHeaders({
      'x-bearer-token': `Bearer ${auth}`,
      'x-api-key': authorization,
      Authorization:
        'cmViUUFLQ0NuQkNUb1BLQXU3d3FNMUFhcENMMnVzWE46Rm5XcjFUendETDNwUmQwZQ',
      'Content-Type': 'application/json',
    });

    const body = {
      semConfDAM: {
        Token: cuerpo,
      },
    };
    return this.http.post(url, body, { headers: headers }).pipe(
      catchError((error) => {
        return throwError(() => new Error('Error en la solicitud'));
      })
    );
  }

  getTokenizacion(celular: string, token: string) {
    const url = `${this.APICENAM}/api/v1/Tokenizacion/CustomQuery/${celular}`;
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.http.get<TokenizacionResponse>(url, { headers });
  }

  generateToken(subject: string): Observable<string> {
    const url = `${this.APICENAM}/api/v1/Tokenizacion/generate?subject=${subject}`;
    return this.http.post(url, {}, { responseType: 'text' });
  }

  cardPayment(bodyRequest: any): Observable<any> {
    return this.http
      .post(`${this.APIURL}/payment/card-payment`, bodyRequest)
      .pipe(
        tap((rspOk: any) => {}),
        catchError((err) => {
          console.log(err);
          return of({
            resultCode: 'ERROR',
            result: {},
          });
        })
      );
  }

  updateDomin(bodyRequest: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: bodyRequest,
    });

    return this.http
      .post(`${this.APIURL}/domiciliation/active`, {}, { headers: headers })
      .pipe(
        tap((rspOk: any) => {
          // Puedes manejar la respuesta exitosa aquí
        }),
        catchError((err) => {
          console.log(err);
          return of({
            resultCode: 'ERROR',
            result: {},
          });
        })
      );
  }

  deleteDomin(bodyRequest: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: bodyRequest,
    });

    return this.http
      .delete(`${this.APIURL}/domiciliation/delete`, { headers: headers })
      .pipe(
        tap((rspOk: any) => {
          // Manejar la respuesta exitosa aquí
        }),
        catchError((err) => {
          console.log(err);
          return of({
            resultCode: 'ERROR',
            result: {},
          });
        })
      );
  }

  loadPayment(
    transactionIdentifier: string,
    token: string,
    uploadCard: boolean
  ): Observable<any> {
    const bodyRequest = {
      transactionIdentifier: transactionIdentifier,
      token: token,
      uploadCard: uploadCard,
    };
    return this.http
      .post(`${this.APIURL}/payment/validateToken`, bodyRequest)
      .pipe(
        tap((rspOk: any) => {
          if(this.arrayLabel){
            try {
              rspOk.paymentScreenData = JSON.parse(this.arrayLabel);
            } catch (e) {
              rspOk.paymentScreenData = this.arrayLabel;
            }
          }
          const { resultCode, errorCode, resultMessage, result } = rspOk;
          if (resultCode === 'ERROR') {
            return rspOk;
          }
          this.setAuthToken(rspOk.result.token);
        }),
        catchError((err) => {
          console.log(err);
          return of({
            resultCode: 'ERROR',
          });
        })
      );
  }

  linkCard(bodyRequest: any): Observable<any> {
    return this.http
      .post(`${this.APIURL}/payment/card-payment/link`, bodyRequest)
      .pipe(
        tap((rspOk: any) => {}),
        catchError((err) => {
          console.log('Servicio vincular tarjeta esta mal...');
          return of();
        })
      );
  }

  encrypCardData(bodyRequest: any): Observable<any> {
    return this.http
      .get(`${this.APIURL}/payment/card-payment/getPublicKey`)
      .pipe(
        map((rspOk: any) => {
          const { error, publicKey } = rspOk;
          if (!error) {
            let inputCard = bodyRequest.cardNumber;
            let inputCvv = bodyRequest.securityCode;
            let encryptor = new JSEncrypt();
            encryptor.setPublicKey(publicKey);
            bodyRequest.cardNumber = encryptor.encrypt(inputCard);
            bodyRequest.securityCode = encryptor.encrypt(inputCvv);
            return {
              error: false,
              bodyRequest: bodyRequest,
            };
          } else {
            return {
              error: true,
              bodyRequest: '',
            };
          }
        }),
        catchError((err) => {
          return of({
            error: true,
            responseMessage: 'generic error encountered',
          });
        })
      );
  }

  enrollPendingAuth(bodyRequest: any): Observable<any> {
    return this.http
      .post(
        `${this.APIURL}/payment/card-payment/enrollPendingAuth`,
        bodyRequest
      )
      .pipe(
        map((rspOk: any) => {
          return rspOk;
        }),
        catchError((err) => {
          return of({
            error: true,
            responseMessage: 'generic error encountered',
          });
        })
      );
  }

  validateAuthResult(bodyRequest: any): Observable<any> {
    return this.http
      .post(
        `${this.APIURL}/payment/card-payment/validateAuthResult`,
        bodyRequest
      )
      .pipe(
        map((rspOk: any) => {
          console.log('respondio servicio validateAuthResult');
          return rspOk;
        }),
        catchError((err) => {
          return of({
            error: true,
            responseMessage: 'generic error encountered',
          });
        })
      );
  }

  setIsNational(isNational: boolean) {
    this.isNational = isNational;
  }

  getIsNational() {
    return this.isNational;
  }

  loadDom(token: string): Observable<any> {
    const bodyRequest = {
      rfc: this.numberphone,
      token: token,
    };
    return this.http
      .post(`${this.APIURL}/payment/validateTokenUpdateCard`, bodyRequest)
      .pipe(
        tap((rspOk: any) => {
          this.tokeNumero = rspOk.result.toke_numero;
          const { resultCode, errorCode, resultMessage, result } = rspOk;
        }),
        catchError((err) => {
          console.log(err);
          return of({
            resultCode: 'ERROR',
          });
        })
      );
  }

  unbindCardPayment(bodyRequest: any): Observable<any> {
    return this.http
      .post(`${this.APIURL}/domiciliation/replace-bank-card`, bodyRequest)
      .pipe(
        tap((rspOk: any) => {}),
        catchError((err) => {
          console.log(err.error);

          return of({
            resultCode: 'ERROR',
            result: {},
            errorCode: err.error.errorCode,
            resultMessage: err.error.resultMessage,
          });
        })
      );
  }

  setAuthToken(tokenAuth: string) {
    this.tokenAuth = tokenAuth;
  }

  getAuthToken() {
    return this.tokenAuth;
  }

  async hashSHA256(input: string): Promise<string> {
    const encoder = new TextEncoder();
    const data = encoder.encode(input);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    return Array.from(new Uint8Array(hashBuffer))
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('');
  }

  getMicroformSrc() {
    return this.microformSrc;
  }

  setMicroformSrc(microformSrc: string) {
    this.microformSrc = microformSrc;
  }

  setMicroformIntegrity(microformIntegrity: string) {
    this.microformIntegrity = microformIntegrity;
  }

  getMicroformIntegrity() {
    return this.microformIntegrity;
  }

  expireTransaction(bodyRequest: any) {
    return this.http
      .post(`${this.APIURL}/payment/card-payment/expire`, {
        transactionIdentifier: this.transactionIdentifier,
      })
      .pipe(
        tap((rspOk: any) => {}),
        catchError((err) => {
          console.log(err);
          return of();
        })
      );
  }
}
